var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewWhiteBrand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_130",
    "data-name": "Group 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 65.13,
    viewBox: "0 0 64 65.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 64,
    height: 65.13,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M32.046,0C13.093,0,1.587,10.218.228,27.86H15.072s-.247-15.211,0-15.458a70.323,70.323,0,0,1,10.21,0c.2.2.194,38.895,0,39.088a72.388,72.388,0,0,1-10.21,0c-.244-.243,0-15.754,0-15.754H.289A31.013,31.013,0,0,0,6.266,52.124s-6.53,12.724-6.258,13S15.545,59.57,15.545,59.57a37.842,37.842,0,0,0,16.5,3.369C52.26,62.939,64,51.32,64,31.469S52.26,0,32.046,0M42.14,51.491a70.475,70.475,0,0,1-10.091,0c-.24-.24-.249-29.365,0-29.612a68.527,68.527,0,0,1,10.091,0c.248.248.243,29.37,0,29.612M37.1,18.443c-4.1,0-5.876-1.48-5.876-4.8C31.219,10.27,33,8.79,37.1,8.79s5.877,1.48,5.877,4.856c0,3.317-1.781,4.8-5.877,4.8",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWhiteBrand);
export default __webpack_public_path__ + "static/media/new_white_brand.dc2e3b3cbd730907fca98a0acd413c63.svg";
export { ForwardRef as ReactComponent };